import React from 'react';
import { useInView } from 'react-intersection-observer';
import { HiGlobeAlt } from 'react-icons/hi';
import { useLanguage } from '../../i18n/LanguageContext';
import './Team.css';

const Team = () => {
  const { t } = useLanguage();
  const [ref, inView] = useInView({ threshold: 0.1, triggerOnce: true });
  const teamMembers = [
    {
      id: 'simo',
      initials: 'SO',
      accent: 'gold',
      image: '/my_profile.png',
      linkedin: 'https://oubia.me',
    },
    {
      id: 'anass',
      initials: 'AN',
      accent: 'cyan',
      image: '/anas.jpeg',
      linkedin: 'https://a-nassiri.me/',
    },
    {
      id: 'ismail',
      initials: 'IA',
      accent: 'gold',
      image: '/ismail.png',
      linkedin: 'http://ismailahouari.dev/',
    },
  ].map((member) => ({
    ...member,
    ...t(`team.members.${member.id}`),
  }));

  return (
    <section className="team" id="team" ref={ref}>
      <div className="team__container">
        <div className="team__header">
          <span className="section-eyebrow" style={{ color: 'var(--gold)' }}>
            {t('team.eyebrow')}
          </span>
          <h2 className="section-title">{t('team.title')}</h2>
          <p className="team__subtitle">
            {t('team.subtitle')}
          </p>
        </div>

        <div className={`team__grid ${inView ? 'team__grid--visible' : ''}`}>
          {teamMembers.map((member, i) => (
            <div
              className="team__card"
              key={i}
              style={{ animationDelay: `${i * 0.1}s` }}
            >
              <div className={`team__avatar team__avatar--${member.accent}`}>
                {member.image ? (
                  <img
                    src={member.image}
                    alt={member.name}
                    className="team__avatar-img"
                  />
                ) : (
                  <span className="team__initials">{member.initials}</span>
                )}
              </div>
              <div className="team__info">
                <h3 className="team__name">{member.name}</h3>
                <span className={`team__role team__role--${member.accent}`}>
                  {member.role}
                </span>
                <p className="team__bio">{member.bio}</p>
                <a
                  href={member.linkedin}
                  className="team__link"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`${member.name} ${t('team.profileAria')}`}
                >
                  <HiGlobeAlt />
                  <span>{t('team.linkLabel')}</span>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Team;
